module.exports = __webpack_public_path__ + "img/28.1e91596e.jpg";